import * as React from 'react';
import { Text } from '@chakra-ui/react';

import { Modal } from '../../../atoms/modal';
import UploadActions from '../../../atoms/upload-actions';
import UploadButtonSection from '../../../atoms/upload-button-section';
import UploadCompleteSection from '../../../molecules/uploadComplete';

interface IProps {
  complete: boolean;
  fileNames: string[];
  onContinue: () => void;
  onUpload: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    modalTitle: string,
    fileNames: string[],
  ) => void;
  onClose: () => void;
  docKey: string;
}

export const ImmigrationStatusPdfCopy: React.FC<IProps> = (props: IProps) => {
  const { docKey } = props;

  const handleUpload = () => {
    props.onUpload(
      'beforeTravel',
      null,
      'immigrationStatusPdfCopy',
      docKey,
      'Immigration Status: PDF',
      props.fileNames,
    );
  };

  const handleOnClose = () => {
    props.onClose();
  };

  return (
    <Modal
      id={'immigrationStatusPdfCopy'}
      show={true}
      title={'Immigration Status: PDF'}
      onClose={handleOnClose}
      hideFooter
    >
      {props.complete ? (
        <UploadCompleteSection fileNames={props.fileNames} onUpload={handleUpload} onContinue={props.onContinue} />
      ) : (
        <>
          <Text>Please upload proof of the immigration status from the online checking service.</Text>

          <UploadButtonSection onUpload={handleUpload}>
            Awaiting upload of <b>Immigration status: PDF</b>
          </UploadButtonSection>

          <UploadActions showEmail={false} complete={props.complete} onContinue={props.onContinue} />
        </>
      )}
    </Modal>
  );
};
